import Offcanvas from "react-bootstrap/Offcanvas";
import axiApi from "ApiCaller";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Form from "react-bootstrap/Form";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import TabOthers from "./TabOthers";
import TabGeneral from "./TabGeneral";
import TabModel from "./TabModel";
import TabAsset from "./TabAsset";
import { SwalAlertClass } from "core/swalClass";
import { useState, useEffect } from "react";
import FormButton from "components/buttons/FormButton";
import MapManagerModal from "components/maps/MapManagerModal";
import { subscribeEvent, unsubscribeEvent } from "core/eventsConnector";
import useCustomTranslation from "core/customTranslation";
import { translations } from "../translations";
import AuthContext from "context/AuthContext";
import { useContext } from "react";
const FormDevice = ({ item, setShowCanvas, showCanvas, title, deviceTypes, deviceModels, deviceGroups, deviceStatus, fetchDevices }) => {
    const Alert = new SwalAlertClass({ confirmButtonText: "Aceptar" });
    const handleClose = () => setShowCanvas(false);
    const [isLoading, setIsLoading] = useState(false);
    const [showMapModal, setShowMapModal] = useState(false);
    const [formData, setFormData] = useState({ ...item });
    const { t: _Tc } = useCustomTranslation(translations);
    const { panel } = useContext(AuthContext);
    useEffect(() => {
        setFormData({ ...item });
        return () => {
            unsubscribeEvent("mapmodal:position:selected", handlePositionSelected);
        };
    }, [item]);

    const clickCancel = () => {
        setShowCanvas(false);
    };
    const handlePositionSelected = (e) => {
        const { lat, lng } = e.detail;
        setFormData((prev) => ({
            ...prev,
            lat: parseFloat(lat.toFixed(6)),
            lng: parseFloat(lng.toFixed(6)),
        }));
        unsubscribeEvent("mapmodal:position:selected", handlePositionSelected);
    };
    const handleModalMap = () => {
        subscribeEvent("mapmodal:position:selected", handlePositionSelected);
        setShowMapModal(true);
    };

    // new handler: allow opening map modal for 'container' or 'gps'
    // removed GPS edit handler to prevent editing device GPS from this form

    const onSubmit = (e) => {
        e.preventDefault();
        let form = new FormData(e.target);
        console.log(form)
        setIsLoading(true);

        axiApi
            .post(`/api/devices/device/`, form)
            .then((resp) => {
                if (resp.data.status) {
                    fetchDevices();
                    Alert.success(_Tc("alert.saved"), _Tc("alert.saved.disp"));
                } else {
                    Alert.warning(_Tc("notify.admin"), _Tc("alert.saved.disp.error"));
                }
            })
            .catch((error) => {
                console.error("Error al enviar la solicitud:", error);
                Alert.error(_Tc("notify.admin"), _Tc("alert.saved.disp.error"));
            })
            .finally(() => {
                setShowCanvas(false);
                setIsLoading(false);
            });
    };

    return (
        <Offcanvas show={showCanvas} onHide={handleClose} placement="end" backdrop="static" style={{ width: "50%" }}>
            <Offcanvas.Header className="preview-canvas" closeButton>
                <div className="preview-icon">
                    <FontAwesomeIcon icon="network-wired" />
                </div>
                <div className="preview-title">
                    <Offcanvas.Title>{title}</Offcanvas.Title>
                </div>
            </Offcanvas.Header>
            <Offcanvas.Body>
                <Form onSubmit={onSubmit}>
                    <input type="hidden" name="id" defaultValue={item.id} />
                    <Tabs defaultActiveKey="general" id="tabs-device-form" className="mb-3 border-0">
                        <Tab eventKey="general" className="mt-5" title="General">
                            <TabGeneral
                                item={formData}
                                deviceTypes={deviceTypes}
                                deviceGroups={deviceGroups}
                                deviceStatus={deviceStatus}
                                handleModalMap={handleModalMap}
                                setFormData={setFormData}
                            />
                        </Tab>

                        <Tab eventKey="models" title="Models">
                            <TabModel item={item} deviceModels={deviceModels} />
                        </Tab>

                        <Tab eventKey="asset" className="mt-5" title={panel.panel_type === "w" ? "Contenedor" : "Puente"}>
                            <TabAsset item={item} />
                        </Tab>

                        <Tab eventKey="others" className="mt-5" title="Otros">
                            <TabOthers item={item} />
                        </Tab>
                    </Tabs>
                    <div className="text-end col-12 p-4 buttons-footer">
                        <button type="button" className="btn btn-secondary me-4" onClick={clickCancel}>
                            Cancelar
                        </button>
                        <FormButton type="submit" className="btn btn-primary" isProcessing={isLoading}>
                            {title}
                        </FormButton>
                    </div>
                </Form>
            </Offcanvas.Body>

            <MapManagerModal
                show={showMapModal}
                setShow={setShowMapModal}
                title={"Dispositivo"}
                initialLat={formData.lat}
                initialLng={formData.lng}
            />
        </Offcanvas>
    );
};

export default FormDevice;
